import { STATUS } from '@features/General'
import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { ISagaCb } from '@typings/requestPayloads'

export interface IExhibitorPotentialValuesPayloadState extends ISagaCb {}

export interface IState {
    status: string
    data: any[]
    errors: any
}

const initialState: IState = {
    status: STATUS.IDLE,
    data: [],
    errors: null
}

const exhibitorPotentialValuesSlice = createSlice({
    name: 'company-statistics/exhibitor-potential-values',
    initialState,
    reducers: {
        onRequest(state, action: PayloadAction<IExhibitorPotentialValuesPayloadState>) {
            state.status = STATUS.RUNNING
        },
        onSuccess(state, action) {
            state.status = STATUS.READY
            state.data = action.payload
        },
        onFailure(state, action) {
            state.status = STATUS.ERROR
            state.errors = action.payload
        }
    }
})

export const exhibitorPotentialValuesActions = exhibitorPotentialValuesSlice.actions
export default exhibitorPotentialValuesSlice.reducer
